import React, { useState } from 'react';


import DocumentAttributes from '../../document/attributes';
import { DocumentSignerConfigProvider } from '../../document/signer_config_context';

import { index as indexCorporateAgreement } from '../agreement/axios';
import {
  create as createDocument,
  update as updateDocument
} from './axios';

const CorporateAgreementDocumentForm = props => {

  const [_document, setDocument] = useState(props?.document || {})

  return(
    <div className="row">
      <div className="col-12">
        <DocumentAttributes
          configuration={{
            entity: {
              key: 'agreements',
              label: I18n.t('activerecord.attributes.corporate/agreement_document.entity_id'),
              placeholder: `-- Selecciona una ${ I18n.t('activerecord.attributes.laboral/hiring_document.entity_id') } --`
            },
            formName: 'corporate_agreement_document',
            context: 'corporate',
            defaultRequestParams: {}
          }}
          actions={{
            indexEntities: indexCorporateAgreement,
            createDocument: createDocument,
            updateDocument: updateDocument,
            showDocumentPath: Routes.corporate_agreement_document_path,
            indexDocumentsPath: Routes.corporate_agreement_documents_path(),
            showCheckListTaskPath: Routes.corporate_check_list_agreement_task_path
          }}
          _document={ _document }
          data={ props?.data }
          currentUser={ props?.currentUser || {} }
          currentCustomer={ props?.currentCustomer || {} }
          callbackSetDocument={ setDocument }
        />
      </div>
    </div>
  )
}

export default CorporateAgreementDocumentForm;
